import React from "react";
import PropTypes from "prop-types";
import FroalaEditor from "react-froala-wysiwyg";

import "froala-editor/js/plugins/emoticons.min";

const N2FroalaBox = ({ onChange, comment }) => {
  const froalaEditorConfig = {
    attribution: false,
    height: 100,
    key: "eHE5C-11F2A2D1E2A5B4D-17d1F1FOOLb2KOPQGe1CWCQVTDWXGcA5A4D4B3E4C2C2E3B1A2==",
    quickInsertEnabled: false,
    placeholderText: "Leave a comment...",
    toolbarButtons: [
      "emoticons",
      "bold",
      "italic",
      "underline",
    ],
    pasteAllowedStyleProps: ["text-decoration", "font-style", "font-weight"],
    wordAllowedStyleProps: ["text-decoration", "font-style", "font-weight"],
    htmlAllowedTags: ["p"],
    emoticonsUseImage: false,
    wordPasteModal: false,
    wordPasteKeepFormatting: false,
    toolbarSticky: false,
    enter: FroalaEditor.ENTER_BR,
  };

  return (
    <FroalaEditor
      model={comment}
      onModelChange={input => onChange(input)}
      tag="textarea"
      config={froalaEditorConfig}
    />
  );
};

N2FroalaBox.propTypes = {
  onChange: PropTypes.func,
  comment: PropTypes.string,
};

N2FroalaBox.defaultProps = {
  onChange: "",
  comment: "",
};

export default N2FroalaBox;
